export default __webpack_public_path__ + "static/media/blogimage2.e0e83085.png";